/* ==========================================================================
   AutoVibe PK — global.js
   Vanilla JS: drawers, AJAX cart (Section Rendering API), variant picker,
   quantity steppers, facets, testimonials carousel.
   ========================================================================== */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-overlay]');

  /* ---------------- Drawer manager ---------------- */
  function anyOpen() {
    return document.querySelector('.drawer.is-open, .facets.is-open');
  }
  function openPanel(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    document.body.classList.add('drawer-open');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    }
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeAll() {
    document.querySelectorAll('.drawer.is-open, .facets.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    document.body.classList.remove('drawer-open');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!anyOpen()) overlay.hidden = true; }, 300);
    }
  }
  window.themeDrawer = { open: openPanel, closeAll: closeAll };

  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-open-drawer]'))) {
      e.preventDefault();
      openPanel(document.querySelector(t.getAttribute('data-open-drawer')));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeAll();
      return;
    }
    if ((t = e.target.closest('[data-search-toggle]'))) {
      e.preventDefault();
      var panel = document.getElementById('SearchPanel');
      if (panel) {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) panel.querySelector('input[type="search"]').focus();
      }
      return;
    }

    /* Quantity steppers */
    if ((t = e.target.closest('[data-qty-btn]'))) {
      e.preventDefault();
      var input = t.closest('.qty').querySelector('input');
      var step = t.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
      var min = parseInt(input.min || '1', 10);
      var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* Quick add (single-variant products) */
    if ((t = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      quickAdd(t);
      return;
    }

    /* Cart line remove (drawer + cart page) */
    if ((t = e.target.closest('[data-line-remove]'))) {
      e.preventDefault();
      changeLine(t.getAttribute('data-line-key'), 0, t);
      return;
    }

    /* Gallery thumbnails */
    if ((t = e.target.closest('[data-thumb]'))) {
      e.preventDefault();
      setActiveMedia(t.getAttribute('data-media-id'));
      return;
    }

    /* Testimonials nav */
    if ((t = e.target.closest('[data-testi-nav]'))) {
      e.preventDefault();
      var track = t.closest('.section').querySelector('.testi-track');
      if (track) {
        var card = track.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 24 : 380;
        track.scrollBy({ left: t.getAttribute('data-testi-nav') === 'next' ? w : -w, behavior: 'smooth' });
      }
      return;
    }

    /* Buy it now */
    if ((t = e.target.closest('[data-buy-now]'))) {
      e.preventDefault();
      var form = t.closest('form') || document.querySelector('[data-product-form]');
      if (form) addToCart(form, t, true);
      return;
    }

    /* Sticky bar -> submit main form */
    if ((t = e.target.closest('[data-sticky-atc]'))) {
      e.preventDefault();
      var mainForm = document.querySelector('[data-product-form]');
      if (mainForm) addToCart(mainForm, t, false);
      return;
    }
  });

  /* ---------------- Cart helpers ---------------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function replaceSections(sections) {
    if (!sections) return;
    var map = { 'cart-drawer': '#CartDrawer-inner', 'main-cart': '#CartPage-inner' };
    Object.keys(map).forEach(function (id) {
      if (!sections[id]) return;
      var target = document.querySelector(map[id]);
      if (!target) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector(map[id]);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  function fetchCartMeta() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      });
  }

  function setBusy(busy) {
    var d = document.getElementById('CartDrawer');
    if (d) d.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function addToCart(form, trigger, redirectToCheckout) {
    var btn = trigger && trigger.tagName === 'BUTTON' ? trigger : form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) errorBox.hidden = true;
    if (btn) { btn.disabled = true; btn.innerHTML = window.theme.strings.adding; }

    var data = new FormData(form);
    data.append('sections', 'cart-drawer,main-cart');
    data.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.json.description || res.json.message || window.theme.strings.cartError;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { alert(msg); }
          return;
        }
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }
        replaceSections(res.json.sections);
        fetchCartMeta();
        openPanel(document.getElementById('CartDrawer'));
        if (btn) btn.innerHTML = window.theme.strings.added;
      })
      .catch(function () { alert(window.theme.strings.cartError); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          setTimeout(function () { btn.innerHTML = original; }, 1600);
        }
      });
  }

  function quickAdd(btn) {
    var original = btn.innerHTML;
    btn.disabled = true;
    var body = {
      items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }],
      sections: 'cart-drawer,main-cart',
      sections_url: window.location.pathname
    };
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.status !== 200) { alert(json.description || window.theme.strings.cartError); return; }
        replaceSections(json.sections);
        fetchCartMeta();
        openPanel(document.getElementById('CartDrawer'));
      })
      .catch(function () { alert(window.theme.strings.cartError); })
      .finally(function () { btn.disabled = false; btn.innerHTML = original; });
  }

  function changeLine(lineKey, quantity, trigger) {
    setBusy(true);
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: 'cart-drawer,main-cart',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        replaceSections(cart.sections);
        if (typeof cart.item_count !== 'undefined') updateCartCount(cart.item_count);
      })
      .catch(function () { alert(window.theme.strings.cartError); })
      .finally(function () { setBusy(false); });
  }

  /* Drawer + cart page quantity inputs (delegated change) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) {
      changeLine(input.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0), input);
      return;
    }
    /* Facets: auto submit (inputs inside the form or associated via form="") */
    var facetsForm = document.getElementById('FacetsForm');
    if (facetsForm && (e.target.closest('#FacetsForm') || e.target.getAttribute('form') === 'FacetsForm')) {
      facetsForm.submit();
    }
  });

  /* Intercept product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form], form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, e.submitter, false);
  });

  /* ---------------- Product page: variant picker ---------------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var jsonTag = document.querySelector('[data-variant-json]');
    var variants = jsonTag ? JSON.parse(jsonTag.textContent) : [];

    function selectedOptions() {
      var opts = [];
      productForm.querySelectorAll('.opt-group').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function renderVariant(variant) {
      var idInput = productForm.querySelector('input[name="id"]');
      var atc = productForm.querySelector('[data-atc]');
      var buyNow = productForm.querySelector('[data-buy-now]');
      var priceEls = document.querySelectorAll('[data-price-current]');
      var compareEls = document.querySelectorAll('[data-price-compare]');
      var saleBadge = document.querySelector('[data-sale-badge]');

      if (!variant) {
        if (atc) { atc.disabled = true; atc.innerHTML = window.theme.strings.unavailable; }
        if (buyNow) buyNow.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;

      priceEls.forEach(function (el) { el.textContent = variant.price_formatted; });
      compareEls.forEach(function (el) {
        el.textContent = variant.compare_formatted || '';
        el.hidden = !variant.on_sale;
      });
      if (saleBadge) {
        saleBadge.hidden = !variant.on_sale;
        if (variant.on_sale && variant.discount_pct) saleBadge.textContent = '-' + variant.discount_pct + '% OFF';
      }
      if (atc) {
        atc.disabled = !variant.available;
        atc.innerHTML = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      if (buyNow) buyNow.disabled = !variant.available;
      if (variant.media_id) setActiveMedia(String(variant.media_id));

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }

    productForm.addEventListener('change', function (e) {
      if (e.target.matches('.opt-group input[type="radio"]')) {
        renderVariant(findVariant(selectedOptions()));
      }
    });
  }

  function setActiveMedia(mediaId) {
    var main = document.querySelector('[data-gallery-main]');
    if (!main || !mediaId) return;
    var thumb = document.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
    if (!thumb) return;
    var img = thumb.querySelector('img');
    var mainImg = main.querySelector('img');
    if (img && mainImg) {
      mainImg.src = img.getAttribute('data-full') || img.src;
      mainImg.srcset = img.getAttribute('data-full-srcset') || '';
      mainImg.alt = img.alt;
    }
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  /* ---------------- Facets drawer (mobile) ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-facets-toggle]');
    if (t) {
      e.preventDefault();
      openPanel(document.querySelector('.facets'));
    }
  });

  /* ---------------- Product recommendations ---------------- */
  var reco = document.querySelector('[data-recommendations]');
  if (reco) {
    var url = window.routes.product_recommendations_url +
      '?section_id=' + reco.getAttribute('data-section-id') +
      '&product_id=' + reco.getAttribute('data-product-id') +
      '&limit=4';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.product-card')) {
          reco.innerHTML = fresh.innerHTML;
        } else {
          var sec = reco.closest('.section');
          if (sec) sec.remove();
        }
      })
      .catch(function () {});
  }
})();
